export default function addChaynsCallErrorListener(req) {
    req.addJsonCallEventListener(75);
}
